import React, { useState, useEffect } from 'react'
import { blindShuffle } from '../utils/SmartLabelUtils'
import { SMALL_DESKTOP } from '../constants'
import 'katex/dist/katex.min.css'
import { RectangleContent } from '../UIUtilsFiles/RectangleContent'
import { SlideQuestion } from '../UIUtilsFiles/SlideQuestion'

function DragAndDropMCQ({
  mcData,
  isPractice,
  completed,
  isActive,
  onValueChange,
  onAttemptChange,
  defaultValue,
  explanationClick,
  onExplanationVisible,
  isVerifyMode,
  handleSuccessChange,
  isEmbeded,
  timerEnd,
  followTheFlow,
  currentPriority,
  onPriorityChange,
  sequenceMessage,
  screenMode,
  handleSucAndFailFeedback
}) {
  const {
    ControlID,
    QuestionText,
    QuestionType,
    Description,
    Options,
    Answers,
    Score,
    Background,
    AnswerColorFill,
    QuestionColorFill,
    QuestionFontSize,
    AnswerFontSize,
    AnswerFillColor,
    QuestionFillColor,
    CorrectAnswerExplanation,
    IncorrectAnswerExplanation,
    AnswerUI,
    NumberOfOptions,
    AnswerType,
    Priority,
    Opacity,
    SequenceHint,
    TextAlign,
    FontStyle,
    Italic,
    Bold
  } = mcData
  const [value, setValue] = useState('')
  const [sortedChoiceValueArray, setSortedChoiceValueArray] = useState([])
  const [dragItem, setDragItem] = useState('')

  useEffect(() => {
    if (defaultValue) {
      setSortedChoiceValueArray(defaultValue.CtlSortedArray)
    } else {
      setSortedChoiceValueArray(blindShuffle(Options))
    }
    if (defaultValue) {
      if (defaultValue.CtlValue) {
        let defaultValueSelected = defaultValue.CtlValue
        setValue(defaultValueSelected)
      }
    } else {
      setValue('')
    }
  }, [defaultValue])

  useEffect(() => {
    if (followTheFlow && currentPriority) {
      if (currentPriority === Priority) {
        sequenceMessage(SequenceHint)
      }
    }
  }, [currentPriority])

  useEffect(() => {
    if (explanationClick && !isEmbeded) {
      explanationValidation()
    }
  }, [explanationClick])

  function explanationValidation() {
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (value === correctAnswer) {
      onExplanationVisible(true, CorrectAnswerExplanation)
    } else {
      onExplanationVisible(false, IncorrectAnswerExplanation)
    }
  }

  useEffect(() => {
    if (timerEnd) {
      validateCorrectAnswer(true, value)
    }
  }, [timerEnd])

  function allowDrop(ev) {
    ev.preventDefault()
  }

  function onDragging(h) {
    setDragItem(h)
  }

  function handleOptionChange(optionValue) {
    onAttemptChange(1)
    setValue(optionValue)
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (optionValue === correctAnswer) {
      handleSuccessChange(true)
    } else {
      handleSuccessChange(false)
    }
    validateCorrectAnswer(false, optionValue)
  }

  function validateAnswer() {
    let isCorrect = false
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    if (value === correctAnswer) {
      isCorrect = true
    } else {
      isCorrect = false
    }
    return isCorrect
  }

  function validateCorrectAnswer(timerValue, optionValue) {
    let answerIndex = Answers[0]
    let correctAnswer = Options[answerIndex].Option
    //Change priority value
    if (onPriorityChange && followTheFlow) {
      if (isPractice) {
        if (optionValue === correctAnswer) {
          onPriorityChange(Priority)
        }
      } else {
        onPriorityChange(Priority)
      }
    }

    if (optionValue === correctAnswer) {
      onValueChange(
        ControlID,
        optionValue,
        Score,
        Score,
        sortedChoiceValueArray,
        timerValue
      )
      if (isEmbeded) {
        handleSucAndFailFeedback(true)
      }
    } else {
      onValueChange(
        ControlID,
        optionValue,
        0,
        Score,
        sortedChoiceValueArray,
        timerValue
      )
      if (isEmbeded) {
        handleSucAndFailFeedback(false)
      }
    }
  }

  return (
    <div
      className='slide-comp-wrapper'
      onClick={() => {
        if (explanationClick && isEmbeded) {
          explanationValidation()
        }
      }}
    >
      <div
        style={{
          width: '100%',
          justifyContent: 'center',
          display: 'flex',
          flex: 1,
          pointerEvents: explanationClick
            ? 'none'
            : completed === 1 || !isActive
            ? 'none'
            : isPractice
            ? followTheFlow
              ? validateAnswer()
                ? 'none'
                : 'auto'
              : 'auto'
            : 'auto',
          fontFamily: FontStyle,
          fontStyle: Italic === 'True' ? 'italic' : 'normal',
          fontWeight: Bold === 'True' ? 'bold' : 'normal'
        }}
      >
        {/* //Horizontal layout greater than 5  */}
        {AnswerUI === 'Horizontal' && NumberOfOptions >= 5 && (
          <div
            style={{
              display: 'flex',
              width: '100%',
              height: '100%',
              justifyContent: 'space-evenly',
              flexDirection: 'column'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '35%',
                justifyContent: 'center'
              }}
            >
              {sortedChoiceValueArray &&
                sortedChoiceValueArray.map((s, index) => {
                  if (index < 3) {
                    return (
                      <div
                        className='card-shadow'
                        style={{
                          display: 'flex',
                          width: '20%',
                          height: isEmbeded ? '90%' : '70%',
                          backgroundColor:
                            value === s.Option ? '#00000080' : AnswerFillColor,
                          margin: '1%',
                          alignItems: 'center',
                          borderRadius: '10px',
                          cursor: 'move',
                          marginTop: isEmbeded ? '1%' : '5%',
                          position: 'relative',
                          justifyContent: TextAlign
                            ? TextAlign === 'left'
                              ? 'left'
                              : TextAlign === 'right'
                              ? 'right'
                              : 'center'
                            : 'center'
                        }}
                        draggable='true'
                        onDragStart={() => onDragging(s.Option)}
                      >
                        <RectangleContent
                          contentType={AnswerType}
                          contentData={s.Option}
                        />
                        {value === s.Option && (
                          <span
                            style={{
                              backgroundColor: '#00000080',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              borderRadius: '10px'
                            }}
                          />
                        )}
                      </div>
                    )
                  }
                })}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '35%',
                justifyContent: 'center'
              }}
            >
              {sortedChoiceValueArray &&
                sortedChoiceValueArray.map((s, index) => {
                  if (index > 2) {
                    return (
                      <div
                        className='card-shadow'
                        style={{
                          display: 'flex',
                          width: '20%',
                          height: isEmbeded ? '90%' : '70%',
                          backgroundColor:
                            value === s.Option ? '#00000080' : AnswerFillColor,
                          margin: '1%',
                          alignItems: 'center',
                          borderRadius: '10px',
                          cursor: 'move',
                          marginTop: isEmbeded ? '1%' : '3%',
                          position: 'relative',
                          justifyContent: TextAlign
                            ? TextAlign === 'left'
                              ? 'left'
                              : TextAlign === 'right'
                              ? 'right'
                              : 'center'
                            : 'center'
                        }}
                        draggable='true'
                        onDragStart={() => onDragging(s.Option)}
                      >
                        <RectangleContent
                          contentType={AnswerType}
                          contentData={s.Option}
                        />

                        {value === s.Option && (
                          <span
                            style={{
                              backgroundColor: '#00000080',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              borderRadius: '10px'
                            }}
                          />
                        )}
                      </div>
                    )
                  }
                })}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                height: '30%',
                justifyContent: 'center'
              }}
            >
              <div
                className='card-shadow'
                style={{
                  display: 'flex',
                  width: '25%',
                  height: '80%',
                  backgroundColor: isVerifyMode
                    ? AnswerFillColor
                    : value !== ''
                    ? AnswerFillColor
                    : '#BDBDBD',
                  alignItems: 'center',
                  borderRadius: '10px',
                  alignSelf: 'center',
                  borderWidth: value !== '' || isVerifyMode ? 2 : 0,
                  borderColor: isVerifyMode
                    ? '#0bff31'
                    : Options[Answers[0]].Option === value
                    ? '#0bff31'
                    : 'red',
                  borderStyle: completed === 1 || isPractice ? 'solid' : 'none',
                  marginTop: '1%',
                  justifyContent: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'center'
                }}
                onDrop={(event) => handleOptionChange(dragItem)}
                onDragOver={(event) => allowDrop(event)}
              >
                {value !== '' || isVerifyMode ? (
                  <RectangleContent
                    contentType={AnswerType}
                    contentData={
                      isVerifyMode ? Options[Answers[0]].Option : value
                    }
                  />
                ) : (
                  <p
                    style={{
                      fontSize: isEmbeded ? '14px' : SMALL_DESKTOP,
                      color: '#757575',
                      margin: 0,
                      textAlign: 'center',
                      padding: '1%'
                    }}
                  >
                    Drop your answer here
                  </p>
                )}
              </div>
            </div>
          </div>
        )}
        {/* //Vertical layout greater than 5  */}
        {AnswerUI === 'Vertical' && NumberOfOptions >= 5 && (
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'space-evenly',
              flexDirection: 'row'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1
              }}
            >
              {sortedChoiceValueArray &&
                sortedChoiceValueArray.map((s, index) => {
                  if (index < 3) {
                    return (
                      <div
                        className='card-shadow'
                        style={{
                          display: 'flex',
                          width: isEmbeded ? '60%' : '50%',
                          height: '30%',
                          backgroundColor:
                            value === s.Option ? '#00000080' : AnswerFillColor,
                          margin: '1%',
                          alignItems: 'center',
                          borderRadius: '10px',
                          alignSelf: 'center',
                          cursor: 'move',
                          marginTop: index === 0 ? '5%' : '3%',
                          position: 'relative',
                          justifyContent: TextAlign
                            ? TextAlign === 'left'
                              ? 'left'
                              : TextAlign === 'right'
                              ? 'right'
                              : 'center'
                            : 'center'
                        }}
                        draggable='true'
                        onDragStart={() => onDragging(s.Option)}
                      >
                        <RectangleContent
                          contentType={AnswerType}
                          contentData={s.Option}
                        />

                        {value === s.Option && (
                          <span
                            style={{
                              backgroundColor: '#00000080',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              borderRadius: '10px'
                            }}
                          />
                        )}
                      </div>
                    )
                  }
                })}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center'
              }}
            >
              {sortedChoiceValueArray &&
                sortedChoiceValueArray.map((s, index) => {
                  if (index > 2) {
                    return (
                      <div
                        className='card-shadow'
                        style={{
                          display: 'flex',
                          width: isEmbeded ? '60%' : '50%',
                          height: '30%',
                          backgroundColor:
                            value === s.Option ? '#00000080' : AnswerFillColor,
                          margin: '1%',
                          alignItems: 'center',
                          borderRadius: '10px',
                          alignSelf: 'center',
                          cursor: 'move',
                          marginBottom: '3%',
                          position: 'relative',
                          justifyContent: TextAlign
                            ? TextAlign === 'left'
                              ? 'left'
                              : TextAlign === 'right'
                              ? 'right'
                              : 'center'
                            : 'center'
                        }}
                        draggable='true'
                        onDragStart={() => onDragging(s.Option)}
                      >
                        <RectangleContent
                          contentType={AnswerType}
                          contentData={s.Option}
                        />

                        {value === s.Option && (
                          <span
                            style={{
                              backgroundColor: '#00000080',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              borderRadius: '10px'
                            }}
                          />
                        )}
                      </div>
                    )
                  }
                })}
            </div>
            <div
              className='card-shadow'
              style={{
                display: 'flex',
                width: '25%',
                height: '30%',
                backgroundColor: isVerifyMode
                  ? AnswerFillColor
                  : value !== ''
                  ? AnswerFillColor
                  : '#BDBDBD',
                alignItems: 'center',
                borderRadius: '10px',
                alignSelf: 'center',
                borderWidth: value !== '' || isVerifyMode ? 2 : 0,
                borderColor: isVerifyMode
                  ? '#0bff31'
                  : Options[Answers[0]].Option === value
                  ? '#0bff31'
                  : 'red',
                borderStyle: completed === 1 || isPractice ? 'solid' : 'none',
                marginRight: '2%',
                justifyContent: TextAlign
                  ? TextAlign === 'left'
                    ? 'left'
                    : TextAlign === 'right'
                    ? 'right'
                    : 'center'
                  : 'center'
              }}
              onDrop={(event) => handleOptionChange(dragItem)}
              onDragOver={(event) => allowDrop(event)}
            >
              {value !== '' || isVerifyMode ? (
                <RectangleContent
                  contentType={AnswerType}
                  contentData={
                    isVerifyMode ? Options[Answers[0]].Option : value
                  }
                />
              ) : (
                <p
                  style={{
                    fontSize: isEmbeded ? '14px' : SMALL_DESKTOP,
                    color: '#757575',
                    margin: 0,
                    textAlign: 'center',
                    padding: '1%'
                  }}
                >
                  Drop your answer here
                </p>
              )}
            </div>
          </div>
        )}
        {/* //Horizontal layout less than 5  */}
        {AnswerUI === 'Horizontal' &&
          NumberOfOptions !== 6 &&
          NumberOfOptions !== 5 && (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                justifyContent: 'space-evenly',
                flexDirection: 'column'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  height: '50%'
                }}
              >
                {sortedChoiceValueArray &&
                  sortedChoiceValueArray.map((s) => (
                    <div
                      className='card-shadow'
                      style={{
                        display: 'flex',
                        width: isEmbeded ? '40%' : '20%',
                        height: isEmbeded ? '60%' : '50%',
                        backgroundColor:
                          value === s.Option ? '#00000080' : AnswerFillColor,
                        margin: '2%',
                        alignItems: 'center',
                        borderRadius: '10px',
                        cursor: 'move',
                        marginTop: isEmbeded ? '1%' : '5%',
                        position: 'relative',
                        justifyContent: TextAlign
                          ? TextAlign === 'left'
                            ? 'left'
                            : TextAlign === 'right'
                            ? 'right'
                            : 'center'
                          : 'center'
                      }}
                      draggable='true'
                      onDragStart={() => onDragging(s.Option)}
                    >
                      <RectangleContent
                        contentType={AnswerType}
                        contentData={s.Option}
                      />
                      {value === s.Option && (
                        <span
                          style={{
                            backgroundColor: '#00000080',
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            borderRadius: '10px'
                          }}
                        />
                      )}
                    </div>
                  ))}
              </div>
              <div
                className='card-shadow'
                style={{
                  display: 'flex',
                  width: isEmbeded ? '30%' : '20%',
                  height: isEmbeded ? '40%' : '30%',
                  backgroundColor: isVerifyMode
                    ? AnswerFillColor
                    : value !== ''
                    ? AnswerFillColor
                    : '#BDBDBD',
                  alignItems: 'center',
                  borderRadius: '10px',
                  alignSelf: 'center',
                  borderWidth: value !== '' || isVerifyMode ? 2 : 0,
                  borderColor: isVerifyMode
                    ? '#0bff31'
                    : Options[Answers[0]].Option === value
                    ? '#0bff31'
                    : 'red',
                  borderStyle: completed === 1 || isPractice ? 'solid' : 'none',
                  marginTop: '1%',
                  position: 'relative',
                  justifyContent: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'center'
                }}
                onDrop={(event) => handleOptionChange(dragItem)}
                onDragOver={(event) => allowDrop(event)}
              >
                {value !== '' || isVerifyMode ? (
                  <RectangleContent
                    contentType={AnswerType}
                    contentData={
                      isVerifyMode ? Options[Answers[0]].Option : value
                    }
                  />
                ) : (
                  <p
                    style={{
                      fontSize: isEmbeded ? '14px' : SMALL_DESKTOP,
                      color: '#757575',
                      margin: 0,
                      textAlign: 'center',
                      padding: '1%'
                    }}
                  >
                    Drop your answer here
                  </p>
                )}
              </div>
            </div>
          )}
        {/* //Vertical layout less than 5  */}
        {AnswerUI === 'Vertical' &&
          NumberOfOptions !== 6 &&
          NumberOfOptions !== 5 && (
            <div
              style={{
                display: 'flex',
                width: '100%',
                height: '100%',
                flexDirection: 'row'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '50%',
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                {sortedChoiceValueArray &&
                  sortedChoiceValueArray.map((s, index) => (
                    <div
                      className='card-shadow'
                      style={{
                        display: 'flex',
                        width: isEmbeded ? '50%' : '30%',
                        height: '25%',
                        backgroundColor:
                          value === s.Option ? '#00000080' : AnswerFillColor,
                        margin: '1%',
                        alignItems: 'center',
                        borderRadius: '10px',
                        alignSelf: 'center',
                        cursor: 'move',
                        position: 'relative',
                        justifyContent: TextAlign
                          ? TextAlign === 'left'
                            ? 'left'
                            : TextAlign === 'right'
                            ? 'right'
                            : 'center'
                          : 'center'
                      }}
                      draggable='true'
                      onDragStart={() => onDragging(s.Option)}
                    >
                      <RectangleContent
                        contentType={AnswerType}
                        contentData={s.Option}
                      />
                      {value === s.Option && (
                        <span
                          style={{
                            backgroundColor: '#00000080',
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            borderRadius: '10px'
                          }}
                        />
                      )}
                    </div>
                  ))}
              </div>
              <div
                className='card-shadow'
                style={{
                  display: 'flex',
                  width: isEmbeded ? '30%' : '25%',
                  height: isEmbeded ? '35%' : '30%',
                  backgroundColor: isVerifyMode
                    ? AnswerFillColor
                    : value !== ''
                    ? AnswerFillColor
                    : '#BDBDBD',
                  alignItems: 'center',
                  borderRadius: '10px',
                  alignSelf: 'center',
                  borderWidth: value !== '' || isVerifyMode ? 2 : 0,
                  borderColor: isVerifyMode
                    ? '#0bff31'
                    : Options[Answers[0]].Option === value
                    ? '#0bff31'
                    : 'red',
                  borderStyle: completed === 1 || isPractice ? 'solid' : 'none',
                  marginRight: isEmbeded ? '2%' : 0,
                  justifyContent: TextAlign
                    ? TextAlign === 'left'
                      ? 'left'
                      : TextAlign === 'right'
                      ? 'right'
                      : 'center'
                    : 'center'
                }}
                onDrop={(event) => handleOptionChange(dragItem)}
                onDragOver={(event) => allowDrop(event)}
              >
                {value !== '' || isVerifyMode ? (
                  <RectangleContent
                    contentType={AnswerType}
                    contentData={
                      isVerifyMode ? Options[Answers[0]].Option : value
                    }
                  />
                ) : (
                  <p
                    style={{
                      fontSize: isEmbeded ? '14px' : SMALL_DESKTOP,
                      color: '#757575',
                      margin: 0,
                      textAlign: 'center',
                      padding: '1%'
                    }}
                  >
                    Drop your answer here
                  </p>
                )}
              </div>
            </div>
          )}
        {/* //Grid layout  */}
        {AnswerUI === 'Grid' && (
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'space-evenly',
              flexDirection: 'row',
              padding: '1%'
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center'
              }}
            >
              {sortedChoiceValueArray &&
                sortedChoiceValueArray.map((s, index) => {
                  if (index < 2) {
                    return (
                      <div
                        className='card-shadow'
                        style={{
                          display: 'flex',
                          width: '80%',
                          height: isEmbeded ? '40%' : '30%',
                          backgroundColor:
                            value === s.Option ? '#00000080' : AnswerFillColor,
                          margin: '1%',
                          alignItems: 'center',
                          borderRadius: '10px',
                          alignSelf: 'center',
                          cursor: 'move',
                          marginBottom: '5%',
                          marginTop: isEmbeded ? '1%' : '5%',
                          position: 'relative',
                          // justifyContent: TextAlign
                          //   ? TextAlign === 'left'
                          //     ? 'left'
                          //     : TextAlign === 'right'
                          //     ? 'right'
                          //     : 'center'
                          //   : 'center'
                          justifyContent: 'center'
                        }}
                        draggable='true'
                        onDragStart={() => onDragging(s.Option)}
                      >
                        <RectangleContent
                          contentType={AnswerType}
                          contentData={s.Option}
                        />
                        {value === s.Option && (
                          <span
                            style={{
                              backgroundColor: '#00000080',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              borderRadius: '10px'
                            }}
                          />
                        )}
                      </div>
                    )
                  }
                })}
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                justifyContent: 'center'
              }}
            >
              {sortedChoiceValueArray &&
                sortedChoiceValueArray.map((s, index) => {
                  if (index > 1) {
                    return (
                      <div
                        className='card-shadow'
                        style={{
                          display: 'flex',
                          width: '80%',
                          height: isEmbeded ? '40%' : '30%',
                          backgroundColor:
                            value === s.Option ? '#00000080' : AnswerFillColor,
                          margin: '1%',
                          alignItems: 'center',
                          borderRadius: '10px',
                          alignSelf: 'center',
                          cursor: 'move',
                          marginBottom: '5%',
                          marginTop: isEmbeded ? '1%' : '5%',
                          position: 'relative',
                          // justifyContent: TextAlign
                          //   ? TextAlign === 'left'
                          //     ? 'left'
                          //     : TextAlign === 'right'
                          //     ? 'right'
                          //     : 'center'
                          //   : 'center'
                          justifyContent: 'center'
                        }}
                        draggable='true'
                        onDragStart={() => onDragging(s.Option)}
                      >
                        <RectangleContent
                          contentType={AnswerType}
                          contentData={s.Option}
                        />
                        {value === s.Option && (
                          <span
                            style={{
                              backgroundColor: '#00000080',
                              position: 'absolute',
                              width: '100%',
                              height: '100%',
                              borderRadius: '10px'
                            }}
                          />
                        )}
                      </div>
                    )
                  }
                })}
            </div>
            <div
              className='card-shadow'
              style={{
                display: 'flex',
                width: '25%',
                height: isEmbeded ? '50%' : '30%',
                backgroundColor: isVerifyMode
                  ? AnswerFillColor
                  : value !== ''
                  ? AnswerFillColor
                  : '#BDBDBD',
                alignItems: 'center',
                borderRadius: '10px',
                alignSelf: 'center',
                borderWidth: value !== '' || isVerifyMode ? 2 : 0,
                borderColor: isVerifyMode
                  ? '#0bff31'
                  : Options[Answers[0]].Option === value
                  ? '#0bff31'
                  : 'red',
                borderStyle: completed === 1 || isPractice ? 'solid' : 'none',

                justifyContent: 'center'
              }}
              onDrop={(event) => handleOptionChange(dragItem)}
              onDragOver={(event) => allowDrop(event)}
            >
              {value !== '' || isVerifyMode ? (
                <RectangleContent
                  contentType={AnswerType}
                  contentData={
                    isVerifyMode ? Options[Answers[0]].Option : value
                  }
                />
              ) : (
                <p
                  style={{
                    fontSize: isEmbeded ? '14px' : SMALL_DESKTOP,
                    color: '#757575',
                    margin: 0,
                    textAlign: 'center',
                    padding: '1%'
                  }}
                >
                  Drop your answer here
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default DragAndDropMCQ
